require('./lib/utils/time').default;
var TimePicker = require('./lib/components/TimePicker').default;

module.exports = TimePicker;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-times/index.js
// module id = 1534
// module chunks = 0